import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const route = 'pole.rf'

export default {
  fetchPoleStatuses() {
    return Repository.get(route + '/catalog/order-statuses')
  },
  fetchPoleBids(params = null) {
    return Repository.get(route + '/orders/index' + getParamsUrl(params))
  },
  getBidsQuantity() {
    return Repository.get(route + '/orders/get-count')
  },
  updatePoleBid(bid) {
    return Repository.post(route + '/orders/update', bid)
  },
  fetchCoefficients(params = null) {
    return Repository.get(route + '/prices/index' + getParamsUrl(params))
  },
  updateCoefficient(data) {
    return Repository.post(route + '/prices/update', data)
  },
}
